import React from 'react'
import { Link, StaticQuery, graphql } from 'gatsby'
import github from '../img/github-icon.svg'
import logo from '../img/logo.png'
import news from '../img/newspaper.svg'
import insta from '../img/instagram.svg'
import bht from '../img/logo.svg'
import video from '../img/video.svg'
import takmicenje from '../img/takmicenje.svg'
import white_logo from '../img/white-logo.svg'
import AnimatedHeader from '../components/AnimatedHeader'
import ThemeSwitcher from '../components/ThemeSwitcher'

const Navbar = () => (
    <>
      <div className="container desktop">
        <nav className="navbar is-transparent desktop">
          <div className="navbar-brand">
            <Link to="/" className="navbar-item" activeClassName="active-navbar-item">
              Vijesti
            </Link>
            <Link to="/predstavljamo" className="navbar-item" activeClassName="active-navbar-item">
              Predstavljamo
            </Link>
            <Link to="/takmicenje" className="navbar-item" activeClassName="active-navbar-item">
              Video takmičenje
            </Link>  
            <Link to="/stream" className="navbar-item" activeClassName="active-navbar-item">
              Pratite uživo
            </Link>
          </div>
        </nav>
          <div className="navbar-brand-right">
            <a href="https://www.bhtelecom.ba" target="_self" className="navbar-sponzor">
              <figure className="image">
                <img src={white_logo} alt="BH Telecom" style={{ width: '88px' }} />
              </figure>
              <em className="navbar-sponzor">&nbsp; Ponosni glavni sponzor Festivala</em>
            </a>
          </div>
      </div>
      <div className="sff-banner desktop">
        <AnimatedHeader />
      </div>
    </>
)

export default Navbar